import toast from 'react-hot-toast';
import { CheckCircle, XCircle, Info } from 'lucide-react';
import { ReactNode } from 'react';
import clsx from 'clsx';

type ToastType = 'success' | 'error' | 'info';

export function showToast({
  message,
  type = 'info',
}: {
  message: string | ReactNode;
  type?: ToastType;
}) {
  const iconMap = {
    success: <CheckCircle className='w-6 h-6 text-green-600' />,
    error: <XCircle className='w-6 h-6 text-red-500' />,
    info: <Info className='w-6 h-6 text-blue-500' />,
  };

  const borderColor =
    type === 'success'
      ? 'border-green-500'
      : type === 'error'
      ? 'border-red-500'
      : 'border-blue-500';

  const progressBarColor =
    type === 'success' ? 'bg-green-500' : type === 'error' ? 'bg-red-500' : 'bg-blue-500';

  toast.remove();
  toast.custom((t) => (
    <div
      className={clsx(
        t.visible ? 'animate-fadeSlideIn' : 'animate-fadeSlideOut',
        'relative max-w-[350px] w-full bg-white shadow-lg rounded-xl p-4 flex gap-4 items-start text-sm border-l-4',
        '!text-[#0E0E0B]',
        borderColor
      )}
    >
      <div className='pt-[2px]'>{iconMap[type]}</div>
      <div className='flex-1'>
        {typeof message === 'string' ? <p className='font-medium'>{message}</p> : message}
      </div>
      <button
        onClick={() => toast.dismiss(t.id)}
        className='text-gray-400 hover:text-gray-600 transition'
      >
        ✖
      </button>

      {/* Progress bar with separate color */}
      <div className='absolute bottom-0 left-0 h-1 w-full bg-gray-200 overflow-hidden rounded-b-md'>
        <div className={clsx('h-full animate-toastProgress', progressBarColor)} />
      </div>
    </div>
  ));
}
